module.exports = __webpack_public_path__ + "static/media/clock-icon.285578e2.png";